import { AccountScopedIdentifier } from '@square/dashboard-protos/models/squareup/bbfrontend/common/identifier/account_scoped_identifier';
export let WithholdingLevel = /*#__PURE__*/function (WithholdingLevel) {
  WithholdingLevel["MERCHANT"] = "MERCHANT";
  WithholdingLevel["UNIT"] = "UNIT";
  return WithholdingLevel;
}({});
export function isUnitWithholding(config) {
  return config.owner?.type === AccountScopedIdentifier.TokenType.TOKEN_TYPE_UNIT;
}
export function isMerchantWithholding(config) {
  return config.owner?.type === AccountScopedIdentifier.TokenType.TOKEN_TYPE_MERCHANT;
}